import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Check if any of the required variables are undefined
const missingVars = Object.entries({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}).filter(([key, value]) => !value);

if (missingVars.length > 0) {
  console.error('Missing environment variables:', missingVars.map(([key]) => key));
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate Firebase config
const validateConfig = () => {
  const requiredFields = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId'
  ];

  const missingFields = requiredFields.filter(field => !firebaseConfig[field]);
  
  if (missingFields.length > 0) {
    console.error('Missing Firebase configuration fields:', missingFields);
    return false;
  }
  
  return true;
};

let app;
let auth;
let googleProvider;
let actionCodeSettings;
let storage;
let db;
let analytics;

try {
  if (validateConfig()) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
    storage = getStorage(app);
    db = getFirestore(app);
    
    // Initialize Analytics if supported
    isSupported().then(yes => yes && (analytics = getAnalytics(app)));
    
    // Configure Google provider
    googleProvider.setCustomParameters({
      prompt: 'select_account'
    });

    // Configure action code settings for email verification
    actionCodeSettings = {
      url: `${window.location.origin}/verify-email`,
      handleCodeInApp: true
    };

    // Initialize Firebase
    auth.useDeviceLanguage();
    auth.settings.appVerificationDisabledForTesting = false;
  } else {
    throw new Error('Firebase initialization failed due to missing configuration');
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  // Initialize with empty objects to prevent undefined errors
  auth = null;
  googleProvider = null;
  actionCodeSettings = null;
  storage = null;
  db = null;
  analytics = null;
}

export { auth, googleProvider, actionCodeSettings, storage, db, analytics };

export default app; 